import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import DnsResultCard from './DnsResultCard';
import { DnsResult } from '../types/dns';

interface IspGroupProps {
  ispName: string;
  results: DnsResult[];
}

const IspGroup: React.FC<IspGroupProps> = ({ ispName, results }) => {
  const workingCount = results.filter(r => r.success).length;
  const totalCount = results.length;
  const isAllWorking = workingCount === totalCount;
  
  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800">{ispName}</h3>
        <div className="flex items-center space-x-2">
          {isAllWorking ? (
            <CheckCircle className="w-5 h-5 text-green-600" />
          ) : (
            <XCircle className="w-5 h-5 text-red-600" />
          )}
          <span className="text-sm text-gray-600">
            {workingCount}/{totalCount} working
          </span>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {results.map((result, index) => (
          <DnsResultCard key={`${result.isp}-${result.dnsServer}-${index}`} result={result} />
        ))}
      </div>
    </div>
  );
};

export default IspGroup;
